// extracted by mini-css-extract-plugin
export var contentGrid = "_o-3";
export var divider = "_o-t";
export var emailInput = "_o-8";
export var emptyDescription = "_o-z";
export var emptyState = "_o-x";
export var emptyTitle = "_o-y";
export var fadeIn = "_o-10";
export var formCard = "_o-5";
export var formGroup = "_o-7";
export var helperText = "_o-9";
export var imagePlaceholder = "_o-n";
export var itemDetails = "_o-l";
export var itemImage = "_o-m";
export var itemInfo = "_o-p";
export var itemName = "_o-q";
export var itemPrice = "_o-s";
export var itemQuantity = "_o-r";
export var itemsList = "_o-j";
export var mainContent = "_o-4";
export var orderItem = "_o-k";
export var orderSummaryCard = "_o-i";
export var pageContainer = "_o-0";
export var pageHeader = "_o-1";
export var pageTitle = "_o-2";
export var paymentDescription = "_o-e";
export var paymentIcon = "_o-b";
export var paymentInfo = "_o-a";
export var paymentMethods = "_o-f";
export var paymentText = "_o-d";
export var placeholderText = "_o-o";
export var sectionTitle = "_o-6";
export var sidebarContent = "_o-h";
export var stripeIcon = "_o-c";
export var submitButton = "_o-g";
export var totalAmount = "_o-w";
export var totalLabel = "_o-v";
export var totalRow = "_o-u";